import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

import { Provider } from 'react-redux';
import { initializeAuth } from './features/authSlice';
import { clearLiveVideo, closeLiveModal, openLiveModal, setLiveVideo } from './features/liveSlice';
import { addNotification, clearNotifications, dismissNotification } from './features/notificationSlice';
import { store } from './store';

// Expose store to window for debugging
if (process.env.NODE_ENV === 'development') {
  window.store = store;
  window.liveActions = {
    openLiveModal,
    closeLiveModal,
    setLiveVideo,
    clearLiveVideo
  };
  window.notificationActions = {
    addNotification,
    dismissNotification,
    clearNotifications
  };
}

// Kick off auth initialisation early so the session check runs in parallel with React rendering
store.dispatch(initializeAuth());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
